export abstract class GeolocationManagerStrategy {
  public abstract watchPosition(
    successCallback: PositionCallback,
    errorCallback: PositionErrorCallback
  ): number;

  public abstract clearWatch(watchId: number): void;
}
